export default __webpack_public_path__ + "static/Entenda0019-85998de4c3ebdcca656da995114fcc4d.jpg";